<ion-header
  class="ion-no-border pick-up-question-modal-header"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-header-modal-tablet'
        : 'ion-header-modal-mobile'
      : 'ion-header-modal-desktop'
  "
>
  <ion-toolbar>
    <ion-buttons *ngIf="platform === platformRef.desktop" slot="end">
      <ion-button
        id="close-modal-button"
        data-cy="pick-up-question-close-modal-icon"
        (click)="dismissModal(false)"
      >
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-label
      class="title"
      data-cy="pick-up-question-label"
      *ngIf="platform !== platformRef.desktop && !isFrozen"
      [class.not-frozen]="!isFrozen"
      [class.title-mobile]="platform === platformRef.mobile"
    >
      {{ title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  data-cy="modal-prompt-area-text"
  class="pick-up-question-modal-content"
  [ngClass]="
    platform !== platformRef.desktop
      ? platform === platformRef.tablet
        ? 'ion-content-modal-tablet'
        : 'ion-content-modal-mobile'
      : 'ion-content-modal-desktop'
  "
>
  <div class="content" [class.touch]="platform !== platformRef.desktop">
    <ion-icon
      *ngIf="withIcon"
      data-cy="pick-up-question-modal-no-image-icon"
      src="../../../../../assets/images/alert-yellow.svg"
      color="Warning"
      class="warning-icon"
      [class.icon-desktop]="platform === platformRef.desktop"
    ></ion-icon>

    <div>
      <h3
        data-cy="pick-up-question-title-text"
        *ngIf="platform === platformRef.desktop || isFrozen"
        [class.title-mobile]="platform === platformRef.mobile"
        [class.title-tablet]="platform === platformRef.tablet"
      >
        {{ title | translate }}
      </h3>

      <h4 *ngIf="!!subtitle" data-cy="pick-up-question-subtitle-text">
        {{ subtitle | translate }}
      </h4>
    </div>
  </div>
</ion-content>

<ion-footer
  class="ion-footer-modal"
  [class.ion-footer-modal-desktop]="platform === platformRef.desktop"
>
  <ion-toolbar>
    <ion-buttons
      [class.buttons-mobile]="platform === platformRef.mobile"
      [class.buttons-not-mobile]="platform !== platformRef.mobile"
    >
      <ion-button
        id="no-modal-btn"
        data-cy="pick-up-question-modal-left-button"
        [ngClass]="[
          platform === platformRef.desktop
            ? 'usf-outline-green-dsktp-tblt-modal-button'
            : 'usf-outline-green-mobile-modal-button'
        ]"
        (click)="handleSubmission(true)"
      >
        {{ leftButtonText | translate }}
      </ion-button>
      <ion-button
        id="yes-modal-btn"
        data-cy="pick-up-question-modal-right-button"
        [ngClass]="[
          platform === platformRef.desktop
            ? 'usf-fill-green-dsktp-tblt-modal-button'
            : 'usf-fill-green-mobile-modal-button'
        ]"
        (click)="handleSubmission(false)"
      >
        {{ rightButtonText | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
